/**
 * static/js/utils/session-timeout.js
 *
 * Reloads the page after a period of inactivity. Bundled into common.js and
 * loaded site-wide; activates only when the page has set
 * window.SESSION_TIMEOUT_MS (logged-in users only — set by a one-line inline
 * shim in base.html / base_tailwind.html that carries the templated duration).
 */
(function (window, document) {
  'use strict';
  var ms = window.SESSION_TIMEOUT_MS;
  if (!ms || !window.jQuery) return;
  var $ = window.jQuery;
  $(function () {
    var timer = 0;
    function reset() {
      clearTimeout(timer);
      timer = setTimeout(function () { window.location.reload(); }, ms);
    }
    $(document).ajaxStart(reset);
    reset();
  });
})(window, document);
